import React, { useEffect } from "react";
import "./HelpDeskStyle.css";
import PrimaryButton from "../../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import PrimaryButtonImg from "../../../components/globalComponents/buttons/primaryButtonImg/PrimaryButtonImg";
import { useState } from "react";
import Checkbox from "../../../components/globalComponents/checkboxes/Checkbox";
import TicketFeedbackPopup from "../../../components/popups/ticketFeedbackPopup/TicketFeedbackPopup";
import {
  helpDeskSliceData,
  getSpecificEnquiry,
  updateEnquiryByStudent,
} from "../../../reducers/helpDeskSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";

const HelpDesk = () => {
  const [openFilters, setOpenFilters] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [enquiryId, setEnquiryId] = useState(null);

  const dispatch = useDispatch();
  const { isFetching, specificEnquiryData, isFeedback } =
    useSelector(helpDeskSliceData);

  useEffect(() => {
    console.log("status", specificEnquiryData[0]?.status);
    dispatch(getSpecificEnquiry());
    // eslint-disable-next-line
  }, [isFeedback]);

  const handleSubmit = (value) => {
    const obj = { id: enquiryId, feedbackVal: value };

    dispatch(updateEnquiryByStudent(obj));
  };

  // const navigateToCreateHelpTicket = () => {
  //     navigate('/createHelpTicket');
  // }
  // const navigateToCreateHelpTicket = () => {
  //     console.log("im here");
  //     navigate('/createHelpTicket');
  // }

  return (
    <>
      {isFetching && <PageLoader />}
      <TicketFeedbackPopup
        show={show}
        handleClose={setShow}
        handleSubmit={handleSubmit}
      />
      <div className="helpDeskOuter">
        <div className="pageHeader">
          <p className="componentHeading"></p>
          <div className="pageTogglers">
            <div className="pageToggler active">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.97325 1.875H14.0268C14.7041 1.87499 15.2505 1.87499 15.6929 1.91114C16.1484 1.94835 16.5485 2.02699 16.9187 2.2156C17.5067 2.51521 17.9848 2.99327 18.2844 3.58128C18.473 3.95146 18.5516 4.35158 18.5889 4.80711C18.625 5.24953 18.625 5.79587 18.625 6.47323V11.2722C18.625 11.8358 18.625 12.2904 18.5998 12.6604C18.5738 13.0409 18.5191 13.3773 18.3871 13.6959C18.07 14.4616 17.4616 15.07 16.6959 15.3871C16.3773 15.5191 16.0409 15.5738 15.6604 15.5998C15.2904 15.625 14.8358 15.625 14.2722 15.625H14.25C13.8129 15.625 13.6954 15.6289 13.594 15.6529C13.4366 15.69 13.29 15.7633 13.1659 15.8669C13.0859 15.9337 13.0123 16.0253 12.75 16.375L11.5212 18.0134C11.4414 18.1198 11.3588 18.2301 11.2806 18.317C11.1958 18.4112 11.0669 18.5361 10.8776 18.6097C10.6347 18.7042 10.3653 18.7042 10.1224 18.6097C9.93311 18.5361 9.80417 18.4112 9.71939 18.317C9.64124 18.2301 9.55858 18.1198 9.47882 18.0134L8.25 16.375C7.98772 16.0253 7.9141 15.9337 7.83411 15.8669C7.70996 15.7633 7.56338 15.69 7.40599 15.6529C7.3046 15.6289 7.18714 15.625 6.75 15.625H6.7278C6.1642 15.625 5.70957 15.625 5.33957 15.5998C4.9591 15.5738 4.62268 15.5191 4.30411 15.3871C3.5384 15.07 2.93005 14.4616 2.61288 13.6959C2.48092 13.3773 2.4262 13.0409 2.40024 12.6604C2.37499 12.2904 2.375 11.8358 2.375 11.2722L2.375 6.47325C2.37499 5.79588 2.37499 5.24953 2.41114 4.80711C2.44835 4.35158 2.52699 3.95146 2.7156 3.58128C3.01521 2.99327 3.49327 2.51521 4.08128 2.2156C4.45146 2.02699 4.85158 1.94835 5.30711 1.91114C5.74953 1.87499 6.29588 1.87499 6.97325 1.875ZM5.4089 3.15699C5.03067 3.18789 4.81337 3.2455 4.64877 3.32936C4.29596 3.50913 4.00913 3.79596 3.82936 4.14877C3.7455 4.31337 3.68789 4.53067 3.65699 4.9089C3.62549 5.29443 3.625 5.78962 3.625 6.5V11.25C3.625 11.841 3.62534 12.2529 3.64734 12.5753C3.66895 12.8922 3.70938 13.0767 3.76773 13.2175C3.95803 13.677 4.32304 14.042 4.78247 14.2323C4.92333 14.2906 5.10784 14.331 5.42466 14.3527C5.74709 14.3747 6.15902 14.375 6.75 14.375C6.77052 14.375 6.79078 14.375 6.8108 14.375C7.15864 14.3748 7.43188 14.3746 7.69318 14.4363C8.03944 14.518 8.3619 14.6793 8.63505 14.9072C8.84117 15.0793 9.00499 15.298 9.21354 15.5763C9.22554 15.5924 9.23769 15.6086 9.25 15.625L10.4667 17.2472C10.4784 17.2629 10.4895 17.2776 10.5 17.2916C10.5105 17.2776 10.5216 17.2629 10.5333 17.2472L11.75 15.625C11.7623 15.6086 11.7745 15.5924 11.7865 15.5763C11.995 15.298 12.1588 15.0793 12.365 14.9072C12.6381 14.6793 12.9606 14.518 13.3068 14.4363C13.5681 14.3746 13.8414 14.3748 14.1892 14.375C14.2092 14.375 14.2295 14.375 14.25 14.375C14.841 14.375 15.2529 14.3747 15.5753 14.3527C15.8922 14.331 16.0767 14.2906 16.2175 14.2323C16.677 14.042 17.042 13.677 17.2323 13.2175C17.2906 13.0767 17.331 12.8922 17.3527 12.5753C17.3747 12.2529 17.375 11.841 17.375 11.25V6.5C17.375 5.78962 17.3745 5.29443 17.343 4.9089C17.3121 4.53067 17.2545 4.31337 17.1706 4.14877C16.9909 3.79596 16.704 3.50913 16.3512 3.32936C16.1866 3.2455 15.9693 3.18789 15.5911 3.15699C15.2056 3.12549 14.7104 3.125 14 3.125H7C6.28962 3.125 5.79443 3.12549 5.4089 3.15699ZM5.70833 8.75C5.70833 8.1747 6.1747 7.70833 6.75 7.70833C7.3253 7.70833 7.79167 8.1747 7.79167 8.75C7.79167 9.3253 7.3253 9.79167 6.75 9.79167C6.1747 9.79167 5.70833 9.3253 5.70833 8.75ZM9.45833 8.75C9.45833 8.1747 9.9247 7.70833 10.5 7.70833C11.0753 7.70833 11.5417 8.1747 11.5417 8.75C11.5417 9.3253 11.0753 9.79167 10.5 9.79167C9.9247 9.79167 9.45833 9.3253 9.45833 8.75ZM13.2083 8.75C13.2083 8.1747 13.6747 7.70833 14.25 7.70833C14.8253 7.70833 15.2917 8.1747 15.2917 8.75C15.2917 9.3253 14.8253 9.79167 14.25 9.79167C13.6747 9.79167 13.2083 9.3253 13.2083 8.75Z"
                  fill="#262626"
                />
              </svg>
              Ticket Record
            </div>
          </div>
          <div>
            <PrimaryButtonImg
              img={"../assets/icons/plus.svg"}
              children={"Raise Ticket"}
              classname={"primaryBtn"}
              onClick={() => navigate("/createHelpTicket")}
            />
          </div>
        </div>
        <div className="filterBar">
          <div className="filterBarLeft">
            {/* <div className="searchBox">
                            <img src="../assets/icons/search-sm.svg" alt="" />
                            <input type="text" className="searchInput" placeholder='Search ...' />
                        </div> */}
            <div className="successTag">
              No. of Tickets: {specificEnquiryData?.length}
            </div>
          </div>
          {/* <button className="fiterBtn" onClick={() => setOpenFilters(!openFilters)}> <img src="../assets/icons/filter-lines.svg" alt="" /> Filters</button> */}
        </div>
        <div className="helpDeskTableOuter">
          <table className="helpDeskTable" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Ticket Id</th>
                <th>Raised On</th>
                <th>Your Query</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th>Status</th>
                <th>Feedback</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {specificEnquiryData &&
                specificEnquiryData?.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <p onClick={() => navigate("/ticketRecord/" + item.id)} className="primaryText pointer">{item.ticketNumber}</p>
                    </td>
                    <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>
                    <td>{item.subject}</td>
                    <td>{item.CategoryMaster.name}</td>
                    <td>{item.SubCategory.name}</td>
                    <td>
                      <p
                        className={
                          item.status === "solved"
                            ? "primaryTag"
                            : item.status === "resolved"
                            ? "successTag"
                            : (item.status === "open" || item.status === null)
                            ? "dangerTag"
                            : "pending"
                        }
                      >
                        {(item.status === "open" || item.status === null) ? "Pending" : item.status === "solved" ? "Solved" : "Resolved"}
                      </p>
                    </td>
                    {/* <td>
                                    {item.CategoryMaster.studentFeedback}
                                    </td> */}
                    <td>
                      {item.status === "resolved" ? (
                        <div className="feedbackImgOuter feedbackEmoji">
                          <div
                            className={`icon ${
                              item.studentFeedback === "satisfied"
                                ? "active"
                                : ""
                            }`}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM7.75 9C7.75 8.30964 8.30964 7.75 9 7.75C9.69036 7.75 10.25 8.30964 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30964 10.25 7.75 9.69036 7.75 9ZM13.75 9C13.75 8.30964 14.3096 7.75 15 7.75C15.6904 7.75 16.25 8.30964 16.25 9C16.25 9.69036 15.6904 10.25 15 10.25C14.3096 10.25 13.75 9.69036 13.75 9ZM8 14C7.4 14.45 7.40018 14.4502 7.40037 14.4505L7.40169 14.4522L7.40395 14.4552L7.41018 14.4634L7.42942 14.488C7.44525 14.508 7.4671 14.535 7.49486 14.5681C7.55031 14.6342 7.62965 14.7247 7.73195 14.8314C7.93593 15.0443 8.23476 15.3254 8.62137 15.6066C9.3917 16.1668 10.5434 16.75 12 16.75C13.4566 16.75 14.6083 16.1668 15.3786 15.6066C15.7652 15.3254 16.0641 15.0443 16.2681 14.8314C16.3704 14.7247 16.4497 14.6342 16.5051 14.5681C16.5329 14.535 16.5547 14.508 16.5706 14.488L16.5898 14.4634L16.596 14.4552L16.5983 14.4522L16.5992 14.451C16.5994 14.4508 16.6 14.45 16 14L16.6 14.45C16.8485 14.1186 16.7814 13.6485 16.45 13.4C16.1188 13.1516 15.649 13.2186 15.4003 13.5496L15.4011 13.5485L15.3945 13.5569C15.3871 13.5662 15.3743 13.5822 15.3562 13.6038C15.3198 13.6471 15.2625 13.7128 15.1851 13.7936C15.0297 13.9557 14.7973 14.1746 14.4964 14.3934C13.8917 14.8332 13.0434 15.25 12 15.25C10.9566 15.25 10.1083 14.8332 9.50363 14.3934C9.20274 14.1746 8.97032 13.9557 8.81493 13.7936C8.73754 13.7128 8.68016 13.6471 8.64382 13.6038C8.62567 13.5822 8.61285 13.5662 8.60549 13.5569L8.59886 13.5485C8.3501 13.2181 7.88098 13.1518 7.55 13.4C7.21863 13.6485 7.15184 14.1191 7.40037 14.4505L8 14Z"
                                fill="#A3A3A3"
                              />
                            </svg>
                          </div>
                          <div
                            className={`icon ${
                              item.studentFeedback === "neutral" ? "active" : ""
                            }`}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM7.75 9C7.75 8.30964 8.30964 7.75 9 7.75C9.69036 7.75 10.25 8.30964 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30964 10.25 7.75 9.69036 7.75 9ZM13.75 9C13.75 8.30964 14.3096 7.75 15 7.75C15.6904 7.75 16.25 8.30964 16.25 9C16.25 9.69036 15.6904 10.25 15 10.25C14.3096 10.25 13.75 9.69036 13.75 9ZM7.25 15C7.25 14.5858 7.58579 14.25 8 14.25H16C16.4142 14.25 16.75 14.5858 16.75 15C16.75 15.4142 16.4142 15.75 16 15.75H8C7.58579 15.75 7.25 15.4142 7.25 15Z"
                                fill="#A3A3A3"
                              />
                            </svg>
                          </div>
                          <div
                            className={`icon ${
                              item.studentFeedback === "unsatisfied"
                                ? "active"
                                : ""
                            }`}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22.7999C6.09995 22.7999 1.19995 17.9 1.19995 12C1.19995 6.09995 6.09995 1.19995 12 1.19995C17.9 1.19995 22.7999 6.09995 22.7999 12C22.7999 17.9 17.9 22.7999 12 22.7999ZM12 2.79995C6.89995 2.79995 2.79995 6.89995 2.79995 12C2.79995 17.1 6.89995 21.2 12 21.2C17.1 21.2 21.2 17.1 21.2 12C21.2 6.89995 17.1 2.79995 12 2.79995ZM16 16.8C15.8 16.8 15.5 16.7 15.4 16.5C15.4 16.5 14.1 14.8 12 14.8C9.89995 14.8 8.59995 16.5 8.59995 16.5C8.29995 16.8 7.89995 16.9 7.59995 16.6C7.29995 16.4 7.19995 15.9 7.49995 15.6C7.59995 15.5 9.29995 13.3 12.1 13.3C14.9 13.3 16.6 15.5 16.7 15.6C16.9 15.9 16.9 16.4 16.6 16.6C16.3 16.7 16.2 16.8 16 16.8ZM15 10.2C14.3 10.2 13.8 9.59995 13.8 8.99995C13.8 8.39995 14.4 7.79995 15 7.79995C15.6 7.79995 16.2 8.39995 16.2 8.99995C16.2 9.59995 15.7 10.2 15 10.2ZM8.99995 10.2C8.29995 10.2 7.79995 9.69995 7.79995 8.99995C7.79995 8.29995 8.29995 7.79995 8.99995 7.79995C9.69995 7.79995 10.2 8.29995 10.2 8.99995C10.2 9.69995 9.69995 10.2 8.99995 10.2Z"
                                fill="#A3A3A3"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : item.status === "solved" ? (
                        <PrimaryButton
                          classname={"darkSecondaryOutlineBtnSmall"}
                          children={"Add Feedback"}
                          onClick={() => {
                            setShow(true);
                            setEnquiryId(item.id);
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      <PrimaryButton
                        children={"View"}
                        classname={"secondaryBtnSmall"}
                        onClick={() => navigate("/ticketRecord/" + item.id)}
                      />
                    </td>
                  </tr>
                ))}
              {/* <tr>
                                <td><p className="primaryText">5031</p></td>
                                <td>9/23/21</td>
                                <td>Sub: I Did Not Received Any..</td>
                                <td>Extra-Curricular Activities</td>
                                <td>-</td>
                                <td><p className="dangerText">Pending</p></td>
                                <td>
                                    <PrimaryButton classname={'darkSecondaryOutlineBtnSmall'} children={'Add Feedback'} onClick={()=>setShow(true)}/>
                                </td>
                                <td><PrimaryButton children={'view'} classname={'secondaryBtnSmall'} /></td>
                            </tr> */}
              {/* <tr>
                                <td><p className="primaryText">5031</p></td>
                                <td>9/23/21</td>
                                <td>Sub: I Did Not Received Any..</td>
                                <td>Extra-Curricular Activities</td>
                                <td>-</td>
                                <td><p className="dangerText">Pending</p></td>
                                <td>
                                    <div className="feedbackImgOuter">
                                        <div className="icon active">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM7.75 9C7.75 8.30964 8.30964 7.75 9 7.75C9.69036 7.75 10.25 8.30964 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30964 10.25 7.75 9.69036 7.75 9ZM13.75 9C13.75 8.30964 14.3096 7.75 15 7.75C15.6904 7.75 16.25 8.30964 16.25 9C16.25 9.69036 15.6904 10.25 15 10.25C14.3096 10.25 13.75 9.69036 13.75 9ZM8 14C7.4 14.45 7.40018 14.4502 7.40037 14.4505L7.40169 14.4522L7.40395 14.4552L7.41018 14.4634L7.42942 14.488C7.44525 14.508 7.4671 14.535 7.49486 14.5681C7.55031 14.6342 7.62965 14.7247 7.73195 14.8314C7.93593 15.0443 8.23476 15.3254 8.62137 15.6066C9.3917 16.1668 10.5434 16.75 12 16.75C13.4566 16.75 14.6083 16.1668 15.3786 15.6066C15.7652 15.3254 16.0641 15.0443 16.2681 14.8314C16.3704 14.7247 16.4497 14.6342 16.5051 14.5681C16.5329 14.535 16.5547 14.508 16.5706 14.488L16.5898 14.4634L16.596 14.4552L16.5983 14.4522L16.5992 14.451C16.5994 14.4508 16.6 14.45 16 14L16.6 14.45C16.8485 14.1186 16.7814 13.6485 16.45 13.4C16.1188 13.1516 15.649 13.2186 15.4003 13.5496L15.4011 13.5485L15.3945 13.5569C15.3871 13.5662 15.3743 13.5822 15.3562 13.6038C15.3198 13.6471 15.2625 13.7128 15.1851 13.7936C15.0297 13.9557 14.7973 14.1746 14.4964 14.3934C13.8917 14.8332 13.0434 15.25 12 15.25C10.9566 15.25 10.1083 14.8332 9.50363 14.3934C9.20274 14.1746 8.97032 13.9557 8.81493 13.7936C8.73754 13.7128 8.68016 13.6471 8.64382 13.6038C8.62567 13.5822 8.61285 13.5662 8.60549 13.5569L8.59886 13.5485C8.3501 13.2181 7.88098 13.1518 7.55 13.4C7.21863 13.6485 7.15184 14.1191 7.40037 14.4505L8 14Z" fill="#A3A3A3" />
                                            </svg>
                                        </div>
                                        <div className="icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM7.75 9C7.75 8.30964 8.30964 7.75 9 7.75C9.69036 7.75 10.25 8.30964 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30964 10.25 7.75 9.69036 7.75 9ZM13.75 9C13.75 8.30964 14.3096 7.75 15 7.75C15.6904 7.75 16.25 8.30964 16.25 9C16.25 9.69036 15.6904 10.25 15 10.25C14.3096 10.25 13.75 9.69036 13.75 9ZM7.25 15C7.25 14.5858 7.58579 14.25 8 14.25H16C16.4142 14.25 16.75 14.5858 16.75 15C16.75 15.4142 16.4142 15.75 16 15.75H8C7.58579 15.75 7.25 15.4142 7.25 15Z" fill="#A3A3A3" />
                                            </svg>
                                        </div>
                                        <div className="icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 22.7999C6.09995 22.7999 1.19995 17.9 1.19995 12C1.19995 6.09995 6.09995 1.19995 12 1.19995C17.9 1.19995 22.7999 6.09995 22.7999 12C22.7999 17.9 17.9 22.7999 12 22.7999ZM12 2.79995C6.89995 2.79995 2.79995 6.89995 2.79995 12C2.79995 17.1 6.89995 21.2 12 21.2C17.1 21.2 21.2 17.1 21.2 12C21.2 6.89995 17.1 2.79995 12 2.79995ZM16 16.8C15.8 16.8 15.5 16.7 15.4 16.5C15.4 16.5 14.1 14.8 12 14.8C9.89995 14.8 8.59995 16.5 8.59995 16.5C8.29995 16.8 7.89995 16.9 7.59995 16.6C7.29995 16.4 7.19995 15.9 7.49995 15.6C7.59995 15.5 9.29995 13.3 12.1 13.3C14.9 13.3 16.6 15.5 16.7 15.6C16.9 15.9 16.9 16.4 16.6 16.6C16.3 16.7 16.2 16.8 16 16.8ZM15 10.2C14.3 10.2 13.8 9.59995 13.8 8.99995C13.8 8.39995 14.4 7.79995 15 7.79995C15.6 7.79995 16.2 8.39995 16.2 8.99995C16.2 9.59995 15.7 10.2 15 10.2ZM8.99995 10.2C8.29995 10.2 7.79995 9.69995 7.79995 8.99995C7.79995 8.29995 8.29995 7.79995 8.99995 7.79995C9.69995 7.79995 10.2 8.29995 10.2 8.99995C10.2 9.69995 9.69995 10.2 8.99995 10.2Z" fill="#A3A3A3" />
                                            </svg>
                                        </div>

                                    </div>
                                </td>
                                <td><PrimaryButton children={'view'} classname={'secondaryBtnSmall'} /></td>
                            </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      <div className={`filterMenuOuter ${openFilters ? "active" : ""}`}>
        <div className="filterMenuContainer">
          <div className="filterMenuHeader">
            <p className="heading">Filter by</p>
            <img
              src="../assets/icons/x-close.svg"
              alt=""
              className="pointer"
              onClick={() => setOpenFilters(false)}
            />
          </div>
          <div className="filterBox">
            <p className="heading">Category</p>
            <ul className="filterItemList">
              <li className="filterItem">
                <Checkbox label={"Industry Immersion Programme"} />
                <Checkbox label={"Extra-Curricular Activities"} />
                <Checkbox label={"Academics"} />
                <Checkbox label={"Facilities"} />
                <Checkbox label={"Career"} />
                <Checkbox label={"Fee"} />
                <Checkbox label={"Others"} />
              </li>
            </ul>
          </div>
          <div className="filterBox">
            <p className="heading">Status</p>
            <div className="radioGrpFlex">
              <div className="radioBtn">
                <input type="radio" id="test3" name="radio-group" />
                <label for="test3">Resolved</label>
              </div>
              <div className="radioBtn">
                <input type="radio" id="test4" name="radio-group" />
                <label for="test4">In Progress</label>
              </div>
            </div>
          </div>
          <div className="filterMenuFooter">
            <PrimaryButton
              classname={"darkSecondaryOutlineBtn"}
              children={"Reset"}
            />
            <PrimaryButton classname={"primaryBtn"} children={"Show Result"} />
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpDesk;
